import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Reminder } from 'structure/launchpad/Reminder';
import { appConfig } from 'utils/app.config';

export const Banner = (props: { onClose: () => void }) => {
  const { t } = useTranslation('common');
  const [isClosed, setIsClosed] = useState(true);

  const handleClose = () => {
    setIsClosed(true);
    sessionStorage?.setItem('isBannerVisible', 'true');
    props.onClose();
  };

  useEffect(() => {
    setIsClosed(Boolean(sessionStorage?.getItem('isBannerVisible')));
  }, []);

  if (!appConfig.featureFlags.ENABLE_BANNER || isClosed) {
    return null;
  }

  return (
    <Reminder
      label={t('HOME_PAGE.SFI_TESTNET_OFFICIALLY')}
      subLabel={t('HOME_PAGE.SFI_TESTNET_OFFICIALLY_SUBTITLE')}
      bgColor='#F5F5F5'
      onClose={handleClose}
    />
  );
};
